"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLimitsPeriods = void 0;
var react_1 = require("react");
// import { LossLimitDurationEnum } from '@l2p/profile-api'
var next_intl_1 = require("next-intl");
var useLimitsPeriods = function () {
    var t = (0, next_intl_1.useTranslations)('lossPeriods');
    return (0, react_1.useMemo)(function () {
        return [];
        // return Object.values(LossLimitDurationEnum).map(value => ({
        //   label: t(`${value}`),
        //   value,
        // }))
    }, []);
};
exports.useLimitsPeriods = useLimitsPeriods;
